module.exports = __webpack_public_path__ + "img/british_airways_logo.17aa0f86.svg";